/* eslint-disable @typescript-eslint/explicit-member-accessibility */
/* eslint-disable no-useless-constructor */
import { reaction } from 'mobx';

type ObserverCallBack = (cs?: any, params?: any) => void | Promise<void>;

export default class BaseObserver {
    model: any;
    callbacks: Array<ObserverCallBack>;
    actionDispose: any;

    constructor(model: Record<string, any>, observerClassOptions?: Record<string, any>) {
        this.model = model;
        this.callbacks = [];
    }

    public addChangesetObserver(callback: ObserverCallBack): void {
        this.model.changeSetEngine.addChangesetObserver(callback);
    }

    public removeChangesetObserver(callback: ObserverCallBack): void {
        this.model.changeSetEngine.removeChangesetObserver(callback);
    }

    public getObserveData(isModelRenderer?: boolean): Record<string, any> {
        return {};
    }

    public addLocalChangeObserver(callback: ObserverCallBack, isModelRenderer?: boolean): void {
        if (callback && this.callbacks.indexOf(callback) < 0) {
            this.callbacks.push(callback);
        }
        if (this.callbacks.length > 0 && !this.actionDispose) {
            this.actionDispose = reaction(() => (this.getObserveData(isModelRenderer)), (obj) => {
                this.notifyLocalChange(obj);
            });
        }
    }

    public notifyLocalChange(obj?: Record<string, any>, params?): void {
        this.callbacks.forEach((cb) => {
            cb(obj ?? this.getObserveData(), params);
        });
    }

    public removeLocalChangeObserver(callback: ObserverCallBack): void {
        const index = this.callbacks.indexOf(callback);
        if (index >= 0) {
            this.callbacks.splice(index, 1);
        }
        if (this.callbacks.length <= 0) {
            this.actionDispose?.();
            this.actionDispose = null;
        }
    }
}
